import { render, staticRenderFns } from "./CoinbasePrimeExchangeInput.vue?vue&type=template&id=854a20b6&"
import script from "./CoinbasePrimeExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./CoinbasePrimeExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports